// extracted by mini-css-extract-plugin
export var messageSideLeft = "_os-1";
export var stateContainer = "_os-0";